import { CollectionToDtoMap } from '../../types';

import { validateAsset } from './validateAsset';
import { validateBeneficiary } from './validateBeneficiary';
import { validateContact } from './validateContact';
import { validatePid } from './validatePid';
import { validatePrivateDocument } from './validatePrivateDocument';

export type ValidatorMap = {
  [K in keyof CollectionToDtoMap]?: (item: CollectionToDtoMap[K]) => {
    valid: boolean;
    fields: (keyof CollectionToDtoMap[K])[];
  };
};

export const validators: ValidatorMap = {
  assets: validateAsset,
  beneficiaries: validateBeneficiary,
  contacts: validateContact,
  personalIdentifiersDocuments: validatePid,
  privateDocuments: validatePrivateDocument,
};
